import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { MDBDataTable } from "mdbreact";
import Histograms from "./Histograms";
import ListA from "../List/ListA";
import ReferringPhysicianList from "../List/referringPhysList";
import ListB from "../List/ListB";
import key from "../../config/key.json";
import errorConfig from "../../config/errorConfig.json";
import { getFromStorage } from "../../utils/storage";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import apiURL from "../../config/api.json";
import { DateRange } from "react-date-range";
import moment from "moment";
import axios from "axios";
import { CircularProgress, Dialog, DialogTitle, DialogContent, Button, DialogActions } from "@material-ui/core";
import { CloudDownload, PictureAsPdf } from "@material-ui/icons";


let startDate = "", endDate = "";

class Forms extends Component {
  //State declarations and initializations
  state = {
    data: {
      columns: [
        {
          label: "#",
          field: "serial_no",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Name of Centres",
          field: "center_name",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Case Uploaded ",
          field: "total_cases",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Case Pending",
          field: "pending_cases",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Case Reported",
          field: "reported_cases",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Normal",
          field: "normal",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Abnormal",
          field: "abnormal",
          sort: "asc",
          width: "auto",
        }
      ],
      rows: []
    },
    histogram1XAxisLabels: [],
    histogram1YAxisData: {
      caseUploaded: [],
      casePending: [],
      caseReported: [],
      normal: [],
      abnormal: []
    },
    histogram2XAxisLabels: ["30", "60", "90", "120", ">120"],
    histogram2YAxisData: [],
    adminListViewArr: [],
    diagnosticListViewArr: [],
    diagnosticRefPhysListArr: [],
    isFetchedList: false,
    isFetchedList1: false,
    selectRange: [{
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    }],
    open: false,
    flag:false,
    centreArray: [],
    ownerTotalCentreWise: [],
    getCenterCaseCount: [],
    getOwnerReportingTime: [],
    getCenterReportingTime: [],
    centre: "",
    isCentre: false
  };

  //Error Notification
  notifyError = error => {
    toast.error("" + error.toString());
  };

  //Fetching Admin List View
  fetchAdminListView = () => {
    this.setState({ isFetchedList1: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "showReportsAdminNCount",
			      owner_id: getFromStorage("owner_id"),
            count: 0
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.setState({ adminListViewArr: res.data, isFetchedList1: true });
        })
        .catch(err => {
          this.setState({ isFetchedList1: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetching Admin List View Between Dates
  fetchAdminListViewBetweenDates = () => {
    this.setState({ isFetchedList1: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getReportFromAdminBetweenDatesNCount",
			      owner_id: getFromStorage("owner_id"),
            date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
            date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD"),
            count: 0
          },
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.setState({ adminListViewArr: res.data, isFetchedList1: true });
        })
        .catch(err => {
          this.setState({ isFetchedList1: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetching Diagnostic List View
  fetchDiagnosticListView = () => {
    this.setState({ isFetchedList1: false }, () => {
      let data = {
        task: "showReportsDiagNCount",
        diag_email: getFromStorage(key.loginInfoKey).email,
        count: 0
      }

      if (this.state.centre.length > 0) {
        data = {
          task: "showReportsDiagNCount",
          diag_name: this.state.centre,
          count: 0
        }
      }

      axios
        .post(
          apiURL.postMethodURL,
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
		if(!res.data.errorMessage) {
          if(this.state.centre.length === 0) {
            this.setState({
              diagnosticListViewArr: res.data,
              isFetchedList1: true
            });
          } else {
            this.setState({
              adminListViewArr: res.data,
              isFetchedList1: true
            });
          }
		}
			this.setState({isFetchedList1: true});
        })
        .catch(err => {
          this.setState({ isFetchedList1: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetching Diagnostic Ref Phys List
  fetchDiagnosticRefPhysListView = () => {
    this.setState({ isFetchedList1: false }, () => {
      let data = {
        task: "showReportsRefPhysDiagNCount",
        diag_email: getFromStorage(key.loginInfoKey).email,
        count: 0
      }

      if (this.state.centre.length > 0) {
        data = {
          task: "showReportsDiagNCount",
          diag_name: this.state.centre,
          count: 0
        }
      }

      axios
        .post(
          apiURL.postMethodURL,
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
		if(!res.data.errorMessage) {
          if(this.state.centre.length === 0) {
            this.setState({
              diagnosticRefPhysListArr: res.data,
              isFetchedList1: true
            });
          } else {
            this.setState({
              adminListViewArr: res.data,
              isFetchedList1: true
            });
          }
		}
			this.setState({isFetchedList1: true});
        })
        .catch(err => {
          this.setState({ isFetchedList1: true });
          this.notifyError(err.toString());
        });
    });
  };


  //Fetching Diagnostic List View Between Dates
  fetchDiagnosticListViewBetweenDates = () => {
    this.setState({ isFetchedList1: false }, () => {
      let data = {
        task: "getReportFromDiagBetweenDatesNCount",
        diag_email: getFromStorage(key.loginInfoKey).email,
        date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
        date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD"),
        count: 0
      }

      if (this.state.centre.length > 0) {
        data = {
          task: "getReportFromDiagBetweenDatesNCount",
          diag_name: this.state.centre,
          date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
          date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD"),
          count: 0
        }
      }

      axios
        .post(
          apiURL.postMethodURL,
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
		if(!res.data.errorMessage)
          if(this.state.centre.length === 0) {
            this.setState({
              diagnosticListViewArr: res.data,
              isFetchedList1: true
            });
          } else {
            this.setState({
              adminListViewArr: res.data,
              isFetchedList1: true
            });
          }
		  this.setState({isFetchedList1: true});
        })
        .catch(err => {
          this.setState({ isFetchedList1: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetching Owner Total Centre Wise
  fetchOwnerTotalCentreWise = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getOwnerCasesCentersWise",
            owner_id: getFromStorage("owner_id"),
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          
          this.getOwnerReportingTime();
          this.setState({
            ownerTotalCentreWise: res.data.map((item, i) => (
              {
                serial_no: i + 1,
                center_name: item.center_name,
                total_cases: item.total_cases,
                pending_cases: item.pending_cases,
                reported_cases: item.reported_cases,
                normal: item.normal,
                abnormal: item.abnormal
              }
            )),
            histogram1XAxisLabels: res.data.map(item => item.center_name),
            histogram1YAxisData: {
              caseUploaded: res.data.map(item => parseInt(item.total_cases)),
              casePending: res.data.map(item => parseInt(item.pending_cases)),
              caseReported: res.data.map(item => parseInt(item.reported_cases)),
              normal: res.data.map(item => parseInt(item.normal)),
              abnormal: res.data.map(item => parseInt(item.abnormal)),
            }
          }, () => {
            this.setState({data: { columns: this.state.data.columns, rows: this.state.ownerTotalCentreWise }})
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetching Owner Total Centre Wise Between Dates
  fetchOwnerTotalCentreWiseBetweenDates = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getOwnerCasesCentersWiseBetweenDates",
            owner_id: getFromStorage("owner_id"),
            date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
            date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD")
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.getOwnerReportingTimeBetweenDates()
          this.setState({
            ownerTotalCentreWise: res.data.map((item, i) => (
              {
                serial_no: i + 1,
                center_name: item.center_name,
                total_cases: item.total_cases,
                pending_cases: item.pending_cases,
                reported_cases: item.reported_cases,
                normal: item.normal,
                abnormal: item.abnormal
              }
            )),
            histogram1XAxisLabels: res.data.map(item => item.center_name),
            histogram1YAxisData: {
              caseUploaded: res.data.map(item => parseInt(item.total_cases)),
              casePending: res.data.map(item => parseInt(item.pending_cases)),
              caseReported: res.data.map(item => parseInt(item.reported_cases)),
              normal: res.data.map(item => parseInt(item.normal)),
              abnormal: res.data.map(item => parseInt(item.abnormal)),
            }
          }, () => {
            this.setState({data: { columns: this.state.data.columns, rows: this.state.ownerTotalCentreWise }})
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getCenterCaseCount
  getCenterCaseCount = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getCenterCaseCount",
            diag_email: getFromStorage(key.loginInfoKey).email,
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.getCenterReportingTime();
          this.setState({
            getCenterCaseCount: res.data.map((item, i) => (
              {
                serial_no: i + 1,
                center_name: item.center_name,
                total_cases: item.total_cases,
                pending_cases: item.pending_cases,
                reported_cases: item.reported_cases,
                normal: item.normal,
                abnormal: item.abnormal
              }
            )),
            histogram1XAxisLabels: res.data.map(item => item.center_name),
            histogram1YAxisData: {
              caseUploaded: res.data.map(item => parseInt(item.total_cases)),
              casePending: res.data.map(item => parseInt(item.pending_cases)),
              caseReported: res.data.map(item => parseInt(item.reported_cases)),
              normal: res.data.map(item => parseInt(item.normal)),
              abnormal: res.data.map(item => parseInt(item.abnormal)),
            }
          }, () => {
            this.setState({data: { columns: this.state.data.columns, rows: this.state.getCenterCaseCount }})
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getCenterCaseCountBetweenDates 
  getCenterCaseCountBetweenDates  = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getCenterCaseCountBetweenDates",
            diag_email: getFromStorage(key.loginInfoKey).email ,
            date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
            date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD")
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.getCenterReportingTimeBetweenDates();
          this.setState({
            getCenterCaseCount: res.data.map((item, i) => (
              {
                serial_no: i + 1,
                center_name: item.center_name,
                total_cases: item.total_cases,
                pending_cases: item.pending_cases,
                reported_cases: item.reported_cases,
                normal: item.normal,
                abnormal: item.abnormal
              }
            )),
            histogram1XAxisLabels: res.data.map(item => item.center_name),
            histogram1YAxisData: {
              caseUploaded: res.data.map(item => parseInt(item.total_cases)),
              casePending: res.data.map(item => parseInt(item.pending_cases)),
              caseReported: res.data.map(item => parseInt(item.reported_cases)),
              normal: res.data.map(item => parseInt(item.normal)),
              abnormal: res.data.map(item => parseInt(item.abnormal)),
            }
          }, () => {
            this.setState({data: { columns: this.state.data.columns, rows: this.state.getCenterCaseCount }})
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getOwnerReportingTime
  getOwnerReportingTime = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getOwnerReportingTime",
            owner_id: getFromStorage("owner_id"),
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.setState({
            isFetchedList: true,
            histogram2XAxisLabels: res.data.map((item, i) => `${item.ReportingTime}`),
            histogram2YAxisData:  {
              ReportingTime: res.data.map(item => item.ReportingTime),
              NumberOfCases: res.data.map(item => item.NumberOfCases)
            }
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getOwnerReportingTimeBetweenDates 
  getOwnerReportingTimeBetweenDates  = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getOwnerReportingTimeBetweenDates",
            owner_id: getFromStorage("owner_id"),
            date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
            date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD")
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          if(res.data.length > 0){
            this.setState({
              isFetchedList: true,
              histogram2XAxisLabels: res.data.map((item, i) => `${item.ReportingTime}`),
              histogram2YAxisData:  {
                ReportingTime: res.data.map(item => item.ReportingTime),
                NumberOfCases: res.data.map(item => item.total_cases)
              }
            });
          } else {
            this.setState({isFetchedList: true, histogram2XAxisLabels: [], histogram2YAxisData: {ReportingTime: [], NumberOfCases: []}})
          }
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getCenterReportingTime
  getCenterReportingTime = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getCenterReportingTime",
            diag_email: getFromStorage(key.loginInfoKey).email,
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          // if(res.data.length > 0) {
          //   const data1 = JSON.stringify(res.data[0]).replace("{", "").replace("}", "").split(",").map(item => item.split(":"));
            
          //   const data = res.data[0];
            this.setState({
              isFetchedList: true,
              histogram2XAxisLabels: res.data.map((item, i) => `${item.ReportingTime}`),
              histogram2YAxisData:  {
                ReportingTime: res.data.map(item => item.ReportingTime),
                NumberOfCases: res.data.map(item => item.total_cases)
              }
            });
          // } else {
          //   this.setState({
          //     isFetchedList: true,
          //     histogram2YAxisData:  [0,0,0,0,0]
          //   });
          // }
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //getCenterReportingTimeBetweenDates 
  getCenterReportingTimeBetweenDates  = () => {
    this.setState({ isFetchedList: false }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "getCenterReportingTimeBetweenDates",
            diag_email: getFromStorage(key.loginInfoKey).email,
            date_from: moment(this.state.selectRange[0].startDate).format("YYYYMMDD"),
            date_to: moment(this.state.selectRange[0].endDate).format("YYYYMMDD")
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.setState({
            isFetchedList: true,
            histogram2XAxisLabels: res.data.map((item, i) => `${item.ReportingTime}`),
            histogram2YAxisData:  {
              ReportingTime: res.data.map(item => item.ReportingTime),
              NumberOfCases: res.data.map(item => item.total_cases)
            }
          });
        })
        .catch(err => {
          this.setState({ isFetchedList: true });
          this.notifyError(err.toString());
        });
    });
  };

  //Fetch Centre List
  fetchCentreList = () => {
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "getCenterList",
          owner_id: getFromStorage("owner_id"),
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        this.setState({
          centreArray: res.data.centerNames
        })
      })
      .catch(err => {
        this.notifyError(err.toString());
      });
  }

  //export to pdf
  exportToPDF = () => {
    axios
    .post("/create/pdf_table", 
    getFromStorage(key.loginInfoKey).task !== "authDiagAdminPanel" ? this.state.ownerTotalCentreWise : this.state.getCenterCaseCount,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
    .then(res => {
      const file = `data:application/pdf;base64,${res.data.Base64}`;
      let a = document.createElement("a");
      a.href = file;
      a.download = `List.pdf`;
      a.click();
    })
    .catch(err => {
      this.notifyError(err)
    })
  }

  //For Today, This week and last 7 days set dates
  setDates = (type) => {
    if(type === "Today") {
      startDate = new Date();
      endDate = new Date();
    } else if(type === "This Week") {
      var current = new Date(); 
      var weekstart = current.getDay() === 0 ? current.getDate() - current.getDay() - 6 : current.getDate() - current.getDay() + 1; 
      startDate = new Date(current.setDate(weekstart));  
      endDate = new Date();  
    } else {
      var currentDate = new Date(); 
      var start =  currentDate.getDate() - 6; 
      startDate = new Date(currentDate.setDate(start));  
      endDate = new Date(); 
    }
    this.setState({ 
        selectRange: [
          {
            startDate,
            endDate,
            key: 'selection',
          }
        ] 
    }, () => {
      this.fetchListBetweenDates()
    })
  }

  fetchListByCentre = (e) => {
    this.setState({open: false, isCentre: true, centre: e.target.value}, () => {
      if(this.state.flag) {
        if(this.state.centre.length > 0){
          this.fetchDiagnosticListViewBetweenDates();
        } else {
          this.fetchAdminListViewBetweenDates();
        }
      } else {
        if(this.state.centre.length > 0){
          this.fetchDiagnosticListView();
        } else {
          this.fetchAdminListView();
        }
      }
    });

    
  }

  //Checking date
  fetchListBetweenDates = () => {
    this.setState({open: false, flag: true}, () => {
      if (getFromStorage(key.loginInfoKey).task === "authAdmin") {
        if(this.state.centre.length > 0) {
            this.fetchDiagnosticListViewBetweenDates();
        } else {
            this.fetchAdminListViewBetweenDates();
        }
          this.fetchOwnerTotalCentreWiseBetweenDates();
        
      } else {
        this.getCenterCaseCountBetweenDates();
        this.fetchDiagnosticListViewBetweenDates();
      }
    })
  };

  //First function run when page load
  componentDidMount() {
    toast.dismiss();
    if (!getFromStorage(key.loginInfoKey)) {
      this.notifyError(errorConfig.notLoggedInError);
      this.props.history.push("/");
    } else if (getFromStorage(key.loginInfoKey).task === "authAdmin") {
      this.fetchCentreList();
      this.fetchOwnerTotalCentreWise(); 
      this.fetchAdminListView();
    } else if (getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel"){
      this.getCenterCaseCount();
      this.fetchDiagnosticListView();
      this.fetchDiagnosticRefPhysListView();
    } else if (getFromStorage(key.loginInfoKey).task === "patient" || getFromStorage(key.loginInfoKey).task === "doctor") {
      this.props.history.push("/home");
    } else if (getFromStorage(key.loginInfoKey).task === "provider") {
      this.props.history.push("/provider_doctors")
    } 
  }

  //Render function for displaying ui on webpage
  render() {
    if (getFromStorage(key.loginInfoKey)) {
      return (
        <div style={{ marginLeft: "80px", color: "teal", marginRight: "20px", marginTop: "110px" }} align="center">
              {this.props.location.pathname !== "/Graph" && getFromStorage(key.loginInfoKey).task === "authAdmin" && 
                <div className="ma2 pa2 dib">
                  <Form.Group >
                    <Form.Label style={{fontWeight: "bold", display: "block"}}>Name of Centre</Form.Label>
                    <Form.Control as="select" style={{width: "300px"}} size="sm" value={this.state.centre} onChange={this.fetchListByCentre}>
                      <option value="">All Centres</option>
                      {this.state.centreArray.map((item, i) =>
                        <option value={item} key={i}>{item}</option>
                      )}
                    </Form.Control>
                  </Form.Group>
                </div>
              }
              <div className="ma2 pa2 dib">
                <Form.Group>
                  <Form.Label style={{fontWeight: "bold", display: "block"}}>Date</Form.Label>
                  <Form.Control type="text" placeholder="Select Date" size="sm" onChange={(e) => {}} value={this.state.flag ? `${moment(this.state.selectRange[0].startDate).format("DD.MM.YYYY")} - ${moment(this.state.selectRange[0].endDate).format("DD.MM.YYYY")}`: ""} 
                    onClick={() => {this.setState({open: true})}} style={{width: "300px", marginLeft: "auto", marginRight: "auto", display: "inline", textAlign: "center"}}/>
                </Form.Group>
              </div>

              {/*Start of Histogram Component*/}
              {this.props.location.pathname === "/Graph" ? (
                <div>
                  {/* <h2 style={{fontWeight: "bold"}}>Monthly</h2> */}
                  {this.state.isFetchedList ? 
                  <div>
                    <div>
                      <Histograms
                        histogram1XAxisLabels={this.state.histogram1XAxisLabels}
                        histogram1YAxisData={this.state.histogram1YAxisData}
                        histogram2XAxisLabels={this.state.histogram2XAxisLabels}
                        histogram2YAxisData={this.state.histogram2YAxisData}
                      />
                    </div>
                  
                    

                      <Button variant="contained" onClick={this.exportToPDF} color="secondary" size="small" style={{textTransform:"none", zIndex: 1, color: "white", position: "absolute", marginLeft: "0px", marginTop: "5px"}}>
                        <PictureAsPdf/> <span style={{marginLeft: "5px"}}>Export To PDF</span>
                      </Button>
                      <MDBDataTable
                        id="table-to-xls"
                        striped
                        responsiveXl
                        bordered
                        small
                        entries={100}
                        pagesAmount={5}
                        data={this.state.data}
                        noBottomColumns
                        hover
                        style={{ background: "white" }}
                      /> 
                    </div>
                    :
                    <div>
                      <CircularProgress />
                      <br/>
                      Fetching Data Please Wait...
                      <br/>
                    </div>

                  }
                </div>
              ) 
		: this.props.location.pathname === "/List" &&
                getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel" ? (
                this.state.isFetchedList1 ? (
                  <ListA
                    listViewArr={this.state.diagnosticListViewArr}
                    fetchListView={this.fetchDiagnosticListView}
                    fetchListViewBetweenDates={
                      this.fetchDiagnosticListViewBetweenDates
                    }
                    fromDate={this.state.selectRange[0].startDate}
                    toDate={this.state.selectRange[0].endDate}
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress />
                    <br />
                    Fetching Data, Please Wait...
                  </div>
                )
              ) 
		: this.props.location.pathname === "/referring_physician_list" &&
                getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel" ? (
                this.state.isFetchedList1 ? (
                  <ReferringPhysicianList
                    listViewArr={this.state.diagnosticRefPhysListArr}
                    fetchListView={this.fetchDiagnosticRefPhysListView}
                    fetchListViewBetweenDates={
                      this.fetchDiagnosticListViewBetweenDates
                    }
                    fromDate={this.state.selectRange[0].startDate}
                    toDate={this.state.selectRange[0].endDate}
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress />
                    <br />
                    Fetching Data, Please Wait...
                  </div>
                )
              ) 
		: this.props.location.pathname === "/List" &&
                getFromStorage(key.loginInfoKey).task === "authAdmin" &&
                this.state.isFetchedList1 ? (
                <ListB listViewArr={this.state.adminListViewArr} />
              ) : (
                <div style={{ textAlign: "center" }}>
                  <CircularProgress />
                  <br />
                  Fetching Data, Please Wait...
                </div>
              )}
          {/*End of Histogram Component*/}
          {/*Start of Dialog*/}
          <Dialog open={this.state.open} aria-labelledby="form-dialog-title">
            {/*Start of Dialog Title*/}
            <DialogTitle id="form-dialog-title" style={{ color: "#484848" }}>
              Select Date
            </DialogTitle>
            {/*End of Dialog Title*/}

            {/*Start of Dialog Content*/}
            <DialogContent style={{textAlign: "center"}} dividers>
              <Button
                style={{textTransform: "none", borderColor: "green", color: "green"}} 
                variant="outlined" 
                size="small"
                onClick={() => this.setDates("Today")}
              >
                Today
              </Button>
              <Button 
                style={{textTransform: "none", marginLeft: "10px", borderColor: "green", color: "green"}} 
                variant="outlined"
                size="small"
                onClick={() => this.setDates("This Week")}
              >
                This Week
              </Button>
              <Button 
                style={{textTransform: "none", marginLeft: "10px", borderColor: "green", color: "green"}} 
                variant="outlined" 
                size="small"
                onClick={() => this.setDates("Last 7 Days")}
              >
                Last 7 Days
              </Button>
              <br/>
              <br/>
              <DateRange
                ranges={this.state.selectRange}
                onChange={(item) => this.setState({ 
                              selectRange: [item.selection], 
                        })}
              />
              <br />
              <br />
            </DialogContent>
            {/*End of Dialog Content*/}

            {/*Start of Dialog Actions*/}
            <DialogActions>
              <Button
                onClick={this.fetchListBetweenDates}
                variant="contained"
                color="primary"
                style={{ textTransform: "none" }}
                className="primary"
              >
                Ok
              </Button>
            </DialogActions>
            {/*End of Dialog Actions*/}
          </Dialog>
          {/*End of Dialog*/}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}
export default withRouter(Forms);
